import React from "react";

const GuestPage = ({ children: content, ...otherProps }) => {
  return <section {...otherProps}>{content}</section>;
};

export default GuestPage;
